"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveStyle = void 0;

var _seamlessImmutable = require("seamless-immutable");

var _colors = _interopRequireDefault(require("../../scss/variables/_colors.scss"));

var _sizes = _interopRequireDefault(require("../../scss/variables/_sizes.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var retrieveStyle = function retrieveStyle(theme) {
  return {
    arrowStyle: {
      fontSize: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'arrowStyle', 'fontSize'], _sizes["default"].defaultCarrouselArrowSize),
      height: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'arrowStyle', 'height'], _sizes["default"].defaultCarrouselArrowSize),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'arrowStyle', 'width'], _sizes["default"].defaultCarrouselArrowSize),
      color: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'arrowStyle', 'color'], _colors["default"].white),
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'arrowStyle', 'backgroundColor'], _colors["default"].lightBlue),
      transition: 'opacity 0.5s ease-out',
      '&:hover': {
        backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'arrowStyle', 'hover', 'backgroundColor'], _colors["default"].lightBlue)
      }
    },
    legendStyleContainer: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'legendStyleContainer', 'backgroundColor'], _colors["default"].gray2),
      height: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'legendStyleContainer', 'height'], _sizes["default"].defaultCarrouselLegendSize),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'legendStyleContainer', 'width'], _sizes["default"].defaultCarrouselLegendSize),
      borderRadius: '100% ',
      userSelect: 'none',
      boxShadow: '0px 1px 2px 0px rgba(0,0,0,0.75)',
      transition: 'transform 0.3s ease-in, background-color 0.3s ease-in',
      transform: 'scale(0.8)'
    },
    legendStyleIsActive: {
      backgroundColor: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'legendStyleIsActive', 'backgroundColor'], _colors["default"].white),
      userSelect: 'none',
      transform: 'scale(1)'
    },
    legendStyleTouchable: {
      alignItems: 'center',
      height: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'legendStyleTouchable', 'height'], _sizes["default"].defaultCarrouselLegendTouchable),
      width: (0, _seamlessImmutable.getIn)(theme, ['UTCarousel', 'legendStyleTouchable', 'width'], _sizes["default"].defaultCarrouselLegendTouchable),
      justifyContent: 'center',
      display: 'flex',
      userSelect: 'none'
    }
  };
};

exports.retrieveStyle = retrieveStyle;